import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
import { FaPen , FaRegTrashAlt, FaPlus, FaBan} from "react-icons/fa";

const Roles = (props) => {
  const sortOptions = [
    { id: 1, value: "enabled", label: "Enabled" },
    { id: 2, value: "all", label: "All" },
  ];
  const [sortBy, setSortBy] = useState(sortOptions[0].value);
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [del, setDelete] = useState(false);
  const [successAlert, setSuccesAlert] = useState(false);
  const [ItemForDelete, setItemForDelete] = useState("initialState");
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage,setErrorMessage]=useState()

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getRoles(token);
  }, []);

  const getRoles = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/roles/?pageSize=-1`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // Sorting Method
        const sortedArray = result?.sort((a, b) => {
          return a.name.localeCompare(b.name) ;
        });
        setData(sortedArray);
      })
      .catch((error) => console.log(" errror", error));
  };

  const handleConfirmation = () => {
    return (
      <SweetAlert
        title="Warning"
        warning
        showCancel={true}
        showConfirm={true}
        btnSize="lg"
        confirmBtnText="Delete"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="secondary"
        onConfirm={() => {
          deleteEntry(ItemForDelete?.id, token);
          setDelete(false);
        }}
        onCancel={() => setDelete(false)}
        show={true}
      >
        {"Are you sure you want to delete ?"}
      </SweetAlert>
    );
  };
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props.history.go(0);
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Role deleted successfully."}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage :"Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const deleteEntry = (ID, token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/roles/${ID}`,requestOptions)
      .then((resp)=> resp.json())
      .then((response) => {
        if (response?.message?.includes("deleted")) {
          setSuccesAlert(true);
        } else {
          setErrorMessage(response?.message)
          setErrorAlert(true);
        }
      }).catch((error) => console.log("error", error));
  };

  
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Roles" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={6} md={12} sm={12}>
                      <Button
                        className="btn btn-success waves-effect waves-light"
                        onClick={() => {
                          props?.history?.push("/add-role");
                        }}
                      >
                        <FaPlus size={12} /> Add New Role
                      </Button>
                    </Col>
                    <Col lg={6} md={12} sm={12} style={{ textAlign: "right" }}>
                      <div className="mb-3">
                        {/* <Label>Discount Type</Label> */}
                        <label htmlFor="cars">Status</label>
                        <select
                          name="cars"
                          defaultValue={sortOptions[0].value}
                          id="cars"
                          onChange={(e) => {
                            setSortBy(e.target.value);
                          }}
                          style={{ width: 80, height: 30, marginLeft: 10 }}
                          options={sortOptions}
                        >
                          {sortOptions?.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                  <div className="table-responsive mt-3">
                    <table
                      style={{}}
                      className="table table-bordered border-primary mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Description</th>
                          <th style={{ width: "10%" }}>Status</th>
                          <th style={{ width: "7%" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => {
                          if (sortBy == "enabled") {
                            if (item?.status !== "Y") {
                              return;
                            }
                          }

                          return (
                            <tr key={index}>
                              <td>{capitalizeFirstLetter(item?.name)}</td>
                              <td>{item?.description}</td>
                              <td>
                                <Button
                                  color={
                                    item.status == "Y" ? "success" : "danger"
                                  }
                                >
                                  {item.status == "Y" ? "Enabled" : "Disabled"}
                                </Button>
                              </td>
                              <td>
                                <Row>
                                  <div className="d-flex justify-content-around">
                                    <div
                                      style={{ width: 30, textAlign: "center" }}
                                      className="text-primary"
                                    >
                                      {item.name!="merchant"?<a
                                        className="font-size-18"
                                        onClick={() => {
                                          props?.history?.push("/add-role", {
                                            edit: true,
                                            item: item,
                                          });
                                        }}
                                      ><FaPen /></a>:<a
                                      className="font-size-16"
                                    ><FaBan /></a>}
                                    </div>

                                    <div style={{ width: 30 }}>
                                      {item.name!="merchant"?<Link to="#" className="px-3 text-danger">
                                        <i
                                          className="font-size-18"
                                          onClick={() => {
                                            setItemForDelete(item);
                                            setDelete(true);
                                          }}
                                        ><FaRegTrashAlt /></i>
                                      </Link>:<Link to="#" className="px-3 text-danger">
                                        <i
                                          className="font-size-16"
                                        ><FaBan /></i>
                                      </Link>}
                                    </div>
                                  </div>
                                </Row>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {del ? handleConfirmation() : null}
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Roles;
